import {
  Button,
  Container,
  Grid,
  Header,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { DocumentContext } from '../../context/documentContext';
import { sentenceItem } from '../../models/interfaces';
interface TopciProps {
  setPageType: (arg: string) => void;
  setShowDetail: (arg: boolean) => void;
  setShowOverview: (arg: boolean) => void;
  setShowSynopsis: () => void;
}
export const TopicOverview = (props: TopciProps) => {
  const { sentences, domains, controls } = useContext(DocumentContext);
  const [domainObligations, setDomainObligations] = useState<string[]>([]);
  const [controlObligations, setControlObligations] = useState<string[]>([]);
  const [domainExpectations, setDomainExpectations] = useState<string[]>([]);
  const [controlExpectations, setControlExpectations] = useState<string[]>([]);
  const [currentButton, setCurrentButton] = useState<string>('');
  const [currentDomainObligation, setCurrentDomainObligation] =
    useState<string>('');
  const [currentDomainExpectation, setCurrentDomainExpectation] =
    useState<string>('');
  const [showDetailPage, setShowDetailPage] = useState<boolean>(false);
  const [pageIdentifier, setPageIdentifier] = useState<string | null>(null);

  const getDomainObligations = () => {
    const obligations = sentences.reduce(
      (acc: string[], curr: sentenceItem) => {
        if (
          !acc.includes(curr.predicted_label_domain) &&
          curr.predicted_label_language === 'ComplianceLanguage' &&
          curr.burden
        ) {
          acc.push(curr.predicted_label_domain);
        }
        return acc;
      },
      [] as string[]
    );
    setDomainObligations(obligations);
  };
  const getDomainExpectations = () => {
    const expectations = sentences.reduce(
      (acc: string[], curr: sentenceItem) => {
        if (
          !acc.includes(curr.predicted_label_domain) &&
          curr.predicted_label_language === 'ComplianceLanguage' &&
          !curr.burden &&
          curr.confidence_score_language > 0.8
        ) {
          acc.push(curr.predicted_label_domain);
        }
        return acc;
      },
      [] as string[]
    );
    setDomainExpectations(expectations);
  };

  useEffect(() => {
    getDomainObligations();
    getDomainExpectations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sentences]);

  return (
    <>
      {!showDetailPage ? (
        <Container
          header={
            <Header
              actions={
                <SpaceBetween direction="horizontal" size="s">
                  <Button onClick={() => props.setShowSynopsis()}>
                    Back to Synopsis
                  </Button>
                  {/* <Button variant="primary" onClick={() => exportSentences()}>
                    Create Report
                  </Button> */}
                </SpaceBetween>
              }
            >
              <SpaceBetween size={'s'}>
                <h1 style={{ margin: '0 0 ' }}>Document Synopsis</h1>
                <h6 style={{ margin: '0 0 ' }}>
                  SECURITY OBLIGATIONS & EXPECTATIONS
                </h6>
                <p style={{ margin: '0 0 ', fontSize: '12px' }}>
                  Obligations, potential negotiation points, and important
                  information discovered in the analyzed document.
                </p>
              </SpaceBetween>
            </Header>
          }
        >
          <div style={{ height: '80vh', overflowY: 'scroll' }}>
            <SpaceBetween direction="vertical" size="s">
              <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                <Container fitHeight header={<h3>Obligations By Topic</h3>}>
                  <SpaceBetween size="s" direction="horizontal">
                    {domainObligations.length > 0
                      ? domainObligations.map((ele) => {
                          return (
                            <Button
                              onClick={() => {
                                props.setPageType(`obligation@${ele}`);
                                props.setShowDetail(true);
                                props.setShowOverview(false);
                                console.log('setting stuff', ele);
                              }}
                            >
                              {ele}
                            </Button>
                          );
                        })
                      : null}
                  </SpaceBetween>
                </Container>
                <Container fitHeight header={<h3>Expectations By Topic</h3>}>
                  <SpaceBetween size="s" direction="horizontal">
                    {domainExpectations.length > 0 ? (
                      domainExpectations.map((ele) => {
                        return (
                          <Button
                            onClick={() => {
                              props.setPageType(`expectations@${ele}`);
                              props.setShowDetail(true);
                              props.setShowOverview(false);
                              console.log('setting stuff', ele);
                            }}
                          >
                            {ele}
                          </Button>
                        );
                      })
                    ) : (
                      <>None Identified</>
                    )}
                  </SpaceBetween>
                </Container>
              </Grid>
            </SpaceBetween>
          </div>
        </Container>
      ) : null}
    </>
  );
};
